export class Job
{
  id?: string;
  No?: string;
  Description?: string;
  SalesPersonRef?: string;
  start?: string;
  end?: string;
  Bill_to_Name?: string;
  Bill_to_Customer_No?: string;
  HasBeenPlannedOn?: boolean;
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/entities/Job.ts